import React, { useState, useEffect } from "react";
import "./IntegrationChoose.css";
import case1 from "../integrationassets/choose1.png";
import case2 from "../integrationassets/choose2.png";
import case3 from "../integrationassets/choose3.png";
import case4 from "../integrationassets/choose4.png";

export default function IntegrationChoose() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [cardsToShow, setCardsToShow] = useState(3);
    
  const cases = [
    {
      img: case1,
      name: "Proven DevOps and Cloud Expertise",
      text: "BastionEx brings deep expertise in DevOps practices and cloud technologies, enabling organizations to build efficient, modern, and resilient CI pipelines.",
    },
    {
      img: case2,
      name: "Secure, compliant CI for enterprise and healthcare.",
      text: "We design CI frameworks with security and compliance at the core, meeting enterprise standards and healthcare regulatory requirements.",
    },
    {
      img: case3,
      name: "Customized Pipelines Aligned with Business Goals",
      text: "Our CI pipelines are tailored to your development workflows, technology stack, and business objectives to deliver maximum value.",
    },
     {
      img: case4,
      name: "Focus on Reliability, Scalability, and Performance",
      text: "We ensure CI pipelines are stable, scalable, and optimized for performance, supporting continuous growth and high availability.",
    },
  ];

  const maxSlides = Math.max(0, cases.length - cardsToShow);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 992) {
        setCardsToShow(3);
      } else if (window.innerWidth >= 576) {
        setCardsToShow(2);
      } else {
        setCardsToShow(1);
      }
      setCurrentSlide(0);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleDotClick = (index) => {
    if (index <= maxSlides) {
      setCurrentSlide(index);
    }
  };

  return (
    <div id="integration-choose" className="outsourcemainclass">
      <h2 className="heading">
        Why Choose BastionEx?
      </h2>
      <p className="subheading">
      Delivering Secure, Compliant, and High-Performance CI Solutions
      </p>

      <div className="cards">
        {cases.map((item, index) => (
          <div className="card" key={index}>
            <img src={item.img} alt="error" />
            <span>{item.name}</span>
            <p className="text">{item.text}</p>
          </div>
        ))}
      </div>

      <div className="carousel-container">
        <div className="carousel-wrapper">
          <div
            className="carousel-track"
            style={{
              transform: `translateX(calc(-${(100 / cardsToShow) * currentSlide}% - ${currentSlide * 12}px))`,
            }}
          >
            {cases.map((item, index) => (
              <div
                className="card"
                key={index}
                style={{
                  flex: `0 0 calc(${100 / cardsToShow}% - ${
                    ((cardsToShow - 1) * 12) / cardsToShow
                  }px)`,
                }}
              >
                <img src={item.img} alt="error" />
                <span>{item.name}</span>
                <p className="text">{item.text}</p>
              </div>
            ))}
          </div>
        </div>

        {maxSlides > 0 && (
          <div className="carousel-dots">
            {Array.from({ length: maxSlides + 1 }).map((_, index) => (
              <button
                key={index}
                className={`dot ${currentSlide === index ? "active" : ""}`}
                onClick={() => handleDotClick(index)}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}